import { render } from "./CustomerRequestTypeDialog.vue?vue&type=template&id=2699a67b&scoped=true"
import script from "./CustomerRequestTypeDialog.vue?vue&type=script&lang=js"
export * from "./CustomerRequestTypeDialog.vue?vue&type=script&lang=js"

import "./CustomerRequestTypeDialog.vue?vue&type=style&index=0&id=2699a67b&scoped=true&lang=css"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2699a67b"]])

export default __exports__